module.exports = __webpack_public_path__ + "img/Differentiation-OVCA_GSE227019.3891041d.png";